import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest, } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { DataService } from '../services/Data/data.service';
import { ITokenObject } from '@interfaces/token.interface';


@Injectable({
  providedIn: 'root',
})
export class InterceptorService implements HttpInterceptor {
  token!: ITokenObject;
  subs: Subscription = new Subscription()
  constructor(private dataService: DataService) {

  }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let REQ_CLONE: any;
    switch (true) {
      case req.url.includes('login'):
        REQ_CLONE = req.clone()
        break;
      default:
        const token =localStorage.getItem("token")
        if(token){
          this.token =  JSON.parse(token).access_token
        }
        REQ_CLONE = req.clone({
          headers: new HttpHeaders({
            Authorization: "Bearer " + this.token,
            'Access-Control-Allow-Origin': '*',
            "Content-Type": "application/json"
          })
        })
        break;
    }

;
    return next.handle(REQ_CLONE);
  }
}

